const U = "?auto=format&fit=crop&w=1200&q=80";

export const IMG = {
  handshake: {
    url: `https://images.unsplash.com/photo-1521791136064-7986c2920216${U}`,
    alt: "Due persone che si stringono la mano in segno di fiducia e di aiuto",
  },
  family: {
    url: `https://images.unsplash.com/photo-1511895426328-dc8714191300${U}`,
    alt: "Una famiglia serena mano nella mano al tramonto",
  },
  community: {
    url: `https://images.unsplash.com/photo-1529156069898-49953e39b3ac${U}`,
    alt: "Un gruppo di persone che ride insieme, serene e unite",
  },
  listening: {
    url: `https://images.unsplash.com/photo-1543269865-cbf427effbad${U}`,
    alt: "Persone sedute a un tavolo che si ascoltano e sorridono",
  },
  children: {
    url: `https://images.unsplash.com/photo-1488521787991-ed7bbaae773c${U}`,
    alt: "Bambini sorridenti e gioiosi",
  },
  smiling: {
    url: `https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e${U}`,
    alt: "Una donna che sorride serena dopo aver superato un momento difficile",
  },
  solidarity: {
    url: `https://images.unsplash.com/photo-1495653797063-114787b77b23${U}`,
    alt: "Mani che si sostengono a vicenda in un gesto di solidarietà",
  },
  psychology: {
    url: `https://images.unsplash.com/photo-1573497491208-6b1acb260507${U}`,
    alt: "Un colloquio sereno di ascolto e supporto psicologico",
  },
};

export const SLUG_IMAGES = {
  "sovraindebitamento-legge-3-2012": IMG.listening,
  "esdebitazione-cancellare-debiti": IMG.smiling,
  "pignoramento-limiti-legge": IMG.family,
  "recupero-crediti-come-difendersi": IMG.community,
  "otto-per-mille-come-destinarlo": IMG.children,
  "debito-e-salute-mentale": IMG.psychology,
  "saldo-e-stralcio-guida": IMG.handshake,
};

export const articleImage = (slug) => SLUG_IMAGES[slug] || IMG.handshake;
